import { render, staticRenderFns } from "./ItemFollowList.vue?vue&type=template&id=c48b09ec&scoped=true&"
import script from "./ItemFollowList.vue?vue&type=script&lang=js&"
export * from "./ItemFollowList.vue?vue&type=script&lang=js&"
import style0 from "./ItemFollowList.vue?vue&type=style&index=0&id=c48b09ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48b09ec",
  null
  
)

export default component.exports